<template>
    <header>
        <div class="row">
            <div class="header-very-top col-12"></div>
        </div>
        <div class="row">
            <div class="col-12 header-top">
                <div class="header-container">
                    <div class="d-flex justify-content-between align-items-center">
                        <router-link :to="{ name: 'index' }">
                            <img
                                src="@assets/images/AOlogo-long.png"
                                alt="Logo"
                                class="logo"
                            />
                        </router-link>
                        <div>
                            <button
                                v-if="$route.name !== 'auth.login'"
                                :class="[buttonSizing, 'btn aoa-btn d-inline']"
                                @click="
                                    () => $router.push({ name: 'auth.login' })
                                "
                            >
                                Login
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-12 header-bottom">
                <div class="header-container">
                    <nav-component class="main-navigation"></nav-component>
                </div>
            </div>
            <div class="mobile-nav">
                <!-- Mobile/Tablet burger menu w/ sidebar -->
                <nav class="main-nav">
                    <Burger></Burger>
                </nav>

                <Sidebar>
                    <nav-component
                        :is-mobile="true"
                        class="sidebar-panel-nav"
                    ></nav-component>
                </Sidebar>
            </div>
        </div>
    </header>
</template>

<script>

import Sidebar from '@/components/Nav/Sidebar';
import Burger from '@/components/Nav/Burger';
import NavComponent from '@/components/Nav/NavComponent';
import { mapGetters } from 'vuex';
import { routing } from '@/mixins/routing';
import { sizing } from '@/mixins/sizing';

export default {
    components: { NavComponent, Sidebar, Burger },
    mixins: [routing, sizing],
    computed: {
        ...mapGetters('Auth', ['isAuthenticated']),
    },
};
</script>
